import { Container } from "@chakra-ui/react";
import LoadingScreen from "components/loading-screen";
import { ReactElement, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Layout from "scenes/layouts";
import OrderService from "services/orders/order-service";
import PaidScene from "./paid";
import PayDetailScene from "./pay";

const PayScene = (): ReactElement => {
    const [isLoading, setLoading] = useState<boolean>(true);
    const [isSubmiting, setIsSubmiting] = useState<boolean>(false);
    const [order, setOrder] = useState<any>(null);
    const [isOrderPaid, setIsOrderPaid] = useState<boolean>(false);
    const { invoiceNo }: any = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        setLoading(true);
        OrderService.GetOrderByInvoice(invoiceNo).then((response: any) => {
            setOrder(response.result);

            const urlParams = new URLSearchParams(window.location.search);
            const transaction_status = urlParams.get('transaction_status');

            if (response.result && (transaction_status == "settlement" || response.result.status == 30))
                setIsOrderPaid(true);
        }).finally(() => {
            setLoading(false);
        });
    }, []);


    if (isLoading)
        return <LoadingScreen />;

    return (
        <Layout>
            <>
                <Container maxWidth={"8xl"}>
                    {
                        order && !isOrderPaid &&
                        <PayDetailScene order={order} />
                    }
                    {
                        order && isOrderPaid &&
                        <PaidScene order={order} />
                    }
                </Container>
            </>
        </Layout>
    );
};

export default PayScene;